<template>
    <div class="main-container cart">
        <div class="people-container p-5">
            <h2>Announcement Cart</h2>
            <div v-if="status == 'loading_cart'">
                <p class="cart-loading"><i class="fad fa-spinner-third fa-spin"></i> Loading Cart...</p>
            </div>
            <div v-if="status != 'loading_cart'">
                <p v-if="!cart" class="cart-empty">Your cart is empty.</p>
                <div class="cart-container" v-if="cart">
                    <div class="cart-header">
                        <div class="header-options">Item</div>
                        <div class="header-description">Description</div>
                        <div class="header-total">Total</div>
                    </div>
                    <div class="cart-items" v-for="(item, index) in cart.items">
                        <div class="item-options">
                            <button class="primary-outline sm" v-on:click="removeItem(item, index)">Remove</button>
                        </div>
                        <div class="item-description">
                            {{ item.first_name }} {{ item.last_name }}
                            <div class="item-product" v-for="product in item.products">
                                {{ product.name }}
                            </div>
                        </div>
                        <div class="item-total">{{ currancy.format(item.amount) }}</div>
                    </div>
                    <div class="cart-footer">
                        Total: <span>{{ currancy.format(cart_total) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-between items-end" v-if="cart">
            <div>
                <p>Add announcement with:</p>
                <button class="primary-outline mr-5" v-on:click="setSameAdType">Same Ad-Type</button>
                <button class="primary-outline" v-on:click="setNewAdType">New Ad-Type</button>
            </div>
            <button class="primary" v-on:click="startCheckout">Checkout</button>
        </div>
        <div class="flex justify-between items-end" v-if="!cart && status != 'loading_cart'">
            <div>
                <button class="primary-outline" v-on:click="setNewAdType">Add Announcement</button>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
    name: "CartView",
    components: {},
    data: function () {
        return {
            token: localStorage.getItem("people_token") ?? "00000000000000000001",
            cart: null,
            currancy: new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }),
            cart_total: 0,
            status: "loading_cart",
        };
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 4 });

        this.getCart();
    },
    watch: {
        cart: {
            deep: true,
            handler(newValue, oldValue) {
                if (this.cart) {
                    this.cart_total = 0;
                    this.cart.items.forEach((item) => {
                        this.cart_total += parseInt(item.amount);
                    });

                    if (this.cart.items.length <= 0) {
                        this.cart = null;
                    }
                }
            },
        },
    },
    methods: {
        startCheckout() {
            localStorage.people_order = JSON.stringify(this.cart.items);
            const router = this.$router;
            router.push("/billing");
        },
        setNewAdType() {
            localStorage.removeItem("people_channels");
            localStorage.removeItem("people_ad_type");
            localStorage.removeItem("people_save_for_later");
            localStorage.removeItem("people_add_on_accounts");
            localStorage.removeItem("people_order_item");

            const router = this.$router;
            router.push("/");
        },
        setSameAdType() {
            const router = this.$router;
            router.push("/builder");
        },
        removeItem(item, index) {
            const vue = this;
            axios.delete(ibj_people_api_url + "api/cart/" + this.token + "/" + item.id).then((response) => {
                this.cart.items.splice(index, 1);

                if (this.cart.items.length <= 0) {
                    localStorage.removeItem("people_token");
                }
            });
        },
        getCart() {
            if (this.token) {
                var vue = this;
                axios
                    .get(ibj_people_api_url + "api/cart/" + this.token)
                    .then((response) => {
                        vue.cart = response.data.cart;
                        vue.status = null;
                    })
                    .catch((error) => {
                        vue.status = null;
                    });
            }
        },
    },
};
</script>

<style>
.cart .main-container.cart {
    max-width: 1080px;
    margin: auto;
    box-sizing: border-box;
}

.cart .cart-header {
    display: flex;
    background-color: #e4e3e2;
    padding: 6px 12px;
    font-weight: 700;
}

.cart .header-options {
    width: 80px;
}

.cart .header-description {
    flex: 1;
    padding-right: 20px;
}

.cart .cart-items {
    display: flex;
    padding: 6px 12px;
    align-items: center;
}

.cart .cart-items:nth-of-type(odd) {
    background-color: #f7f7f7;
}

.cart .item-options {
    width: 80px;
}

.cart .item-description {
    flex: 1;
    padding-right: 20px;
}

.cart .item-product {
    margin-left: 12px;
    font-size: 14px;
}

.cart .cart-footer {
    font-weight: 700;
    text-align: right;
    padding: 6px 12px;
}

.cart .cart-footer span {
    color: #1f9d55;
}

.cart .cart-loading {
    font-size: 16px;
    text-align: center;
}

.cart .cart-empty {
    font-size: 16px;
    text-align: center;
    background-color: #cce8f4;
    border-radius: 4px;
    border: solid 1px #a2b8c3;
    max-width: 360px;
    margin: auto;
    padding: 14px;
    color: #2f5673;
}
</style>
